import { RootState } from 'src/redux/root'
import { getProject } from 'src/redux/slices/project/endpoints'

import Box from '@material-ui/core/Box'

import Task from './Task'
import { TaskActionAnalyzeResults, TaskDetailAnalyzeResults } from './TaskAnalyzeResults'
import { TaskActionAssignTemplates, TaskDetailAssignTemplates } from './TaskAssignTemplates'
import { TaskActionBuildBaseline, TaskDetailBuildBaseline } from './TaskBuildBaseline'
import { TaskActionCreateScenarios, TaskDetailCreateScenarios } from './TaskCreateScenarios'
import { TaskActionGIS, TaskDetailGIS } from './TaskGIS'
import { TaskActionRunSimulations, TaskDetailRunSimulations } from './TaskRunSimulations'
import { TaskActionSegment, TaskDetailSegment } from './TaskSegmentation'
import { TaskActionSurvey, TaskDetailSurvey } from './TaskSurvey'
import { TaskProps } from './TaskTypes'

type TaskListItem = Omit<TaskProps, 'index'>

const TasksList: TaskListItem[] = [
  {
    DetailsComponent: TaskDetailSurvey,
    ActionsComponent: TaskActionSurvey,
    title: 'Define Project Scope & Key Data',
    role: 'Champion',
  },
  {
    DetailsComponent: TaskDetailGIS,
    ActionsComponent: TaskActionGIS,
    title: 'Provide GIS Data',
    role: 'GIS Manager',
    completeSelector: (state: RootState) =>
      !!getProject.select('')(state).data?.archetypeDefinition,
  },
  {
    DetailsComponent: TaskDetailSegment,
    ActionsComponent: TaskActionSegment,
    title: 'Segment Building Stock',
    role: 'Energy Modeler',
  },
  {
    DetailsComponent: TaskDetailAssignTemplates,
    ActionsComponent: TaskActionAssignTemplates,
    title: 'Assign Building Templates to Archetypes',
    role: 'Energy Modeler',
  },
  {
    DetailsComponent: TaskDetailBuildBaseline,
    ActionsComponent: TaskActionBuildBaseline,
    title: 'Build Baseline UBEM',
    role: 'Energy Modeler',
  },
  {
    DetailsComponent: TaskDetailCreateScenarios,
    ActionsComponent: TaskActionCreateScenarios,
    title: 'Create Upgrade Scenarios',
    role: 'Energy Modeler',
  },
  {
    DetailsComponent: TaskDetailRunSimulations,
    ActionsComponent: TaskActionRunSimulations,
    title: 'Run UBEM Simulations',
    role: 'Energy Modeler',
  },
  {
    DetailsComponent: TaskDetailAnalyzeResults,
    ActionsComponent: TaskActionAnalyzeResults,
    title: 'Analyze Results',
    role: 'Team',
  },
]

const Tasks: React.FC = () => {
  return (
    <Box>
      {TasksList.map((props, index) => (
        <Task key={`task-${props.title}-${index}`} {...props} index={index + 1} />
      ))}
    </Box>
  )
}
export default Tasks
